import React, { useState } from "react";

import "./index.sass";
import { useTranslation } from "react-i18next";
import Context from "../../../../../../../../context";
import {
  CustomButton2,
  CustomModal,
  CustomView,
  UserInformation,
} from "../../../../../../../../components";
import api from "../../../../../../../../api";
import successHandler from "../../../../../../../../utils/successHandler";

const Approve = () => {
  const { showModal, setShowModal, selectedPayment } = React.useContext(
    Context.ApproveParentTransactionScreen
  );

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const approveFunction = async (item: any) => {
    setIsLoading(true);
    const result = await api.get.administrator.approveparentTransaction({
      transactionId: item?._id,
    });
    if (result?.CODE === 2213) {
      setIsLoading(false);
      setShowModal("NONE");
      successHandler(2010)
    }
  };

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  const { t } = useTranslation();

  return (
    <section id="driver-approve-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "APPROVE_PARENT_TRANSACTION_MODAL"}
        label="تایید پرداخت"
      >
        <CustomView.Container className="approve-form-content">
          <CustomView.Row className="user-information-container">
            <CustomView.Column>
              {"شما در حال تایید پرداخت می باشید"}{" "}
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="form-row">
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() => setShowModal!("NONE")}
                title="لغو"
                type="danger"
              />
            </CustomView.Column>
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() => approveFunction!(selectedPayment)}
                title={t("approve")}
              />
            </CustomView.Column>
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default Approve;
